"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var createTextFragments_1 = __importDefault(require("./createTextFragments"));

var getTreeNode_1 = require("./getTreeNode");

function parseBlockTree(flat) {
  var state = {
    blocks: [],
    entityMap: flat.entityMap
  };
  var text = [];
  var path = [];
  flat.value.forEach(function (char, index) {
    if ((char.type === 'block-end' || char.type === 'block-start') && text.length > 0) {
      var node = getTreeNode_1.getNode(state, path);
      node.fragments = createTextFragments_1.default(text, flat.entityMap);
      node.value = text;
      text = [];
    }

    if (char.type === 'block-start') {
      var blocks = getTreeNode_1.getNodes(state, path);
      blocks.push({
        fragments: [],
        value: [],
        blocks: [],
        blockKey: char.blockKey,
        styles: char.styles != null ? char.styles : [],
        entity: char.entity != null ? flat.entityMap[char.entity] : null
      });
      path.push(blocks.length - 1);
    } else if (char.type === 'block-end') {
      path.pop();
    } else {
      if (path.length === 0) {
        throw new Error("Invalid List State");
      }

      text.push(char);
    }
  });
  return state;
}

exports.default = parseBlockTree;